import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { GuideSteps } from "@/components/AnyAppSection";
import { useAuth } from "@/context/AuthContext";
import { isInstalled } from "@/lib/install";

const KEY = "mulankan_typing_guide_seen";

export default function TypingGuide() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const [seen, setSeen] = useState(() => localStorage.getItem(KEY) === "1");
  const open = !!user && !seen && isInstalled() && pathname !== "/listen";
  const close = () => { localStorage.setItem(KEY, "1"); setSeen(true); };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()} className="grid-cols-[minmax(0,1fr)] w-[calc(100%-2rem)] bg-[#14110E] border-white/10 text-[var(--ink)] max-w-md rounded-3xl max-h-[90vh] overflow-y-auto" data-testid="typing-guide-dialog">
        <DialogTitle className="font-serif text-2xl">Use Mulankan while typing</DialogTitle>
        <DialogDescription className="text-sm text-white/55">Add a one-tap button so you can speak from WhatsApp, Gmail or any app, then paste the polished text.</DialogDescription>
        <div className="mt-2"><GuideSteps testId="typing-guide" /></div>
        <button onClick={close} data-testid="typing-guide-done" className="btn-accent w-full justify-center mt-2">Got it</button>
      </DialogContent>
    </Dialog>
  );
}
